export default "__VITE_ASSET__DP$hRDoO__"